const gridItems = document.querySelectorAll('.grid-item');
const fullScreenOverlay = document.querySelector('.full-screen-overlay');
const fullScreenImage = document.querySelector('.full-screen-image');
let currentIndex = 0;

// removing this for now
// gridItems.forEach((item, index) => {
//   item.addEventListener('click', () => {
//     navigateTo(index)

//     fullScreenOverlay.style.display = 'flex';
//     document.body.style.overflow = 'hidden'; // Prevent scrolling when full-screen
//     document.querySelector('header').style.display = 'none'
//   });
// });

function closeFullscreen() {
  fullScreenOverlay.style.display = 'none';
  document.body.style.overflow = ''; // Re-enable scrolling
  document.querySelector('header').style.display = '';
}

// Navigate left and right in full-screen mode
document.addEventListener('keydown', (event) => {
  if (fullScreenOverlay.style.display === 'flex') {
    if (event.key === 'ArrowLeft') {
      navigateLeft();
    } else if (event.key === 'ArrowRight') {
      navigateRight();
    }
  }
});

function navigateLeft() {
  navigateTo(currentIndex - 1)
}

function navigateRight() {
  navigateTo(currentIndex + 1)
}

function navigateTo(index) {
  currentIndex = (index) % gridItems.length;
  gridItem = gridItems[currentIndex];
  const imgTitle = gridItem.querySelector('.description').textContent;
  const imgSrc = gridItem.querySelector('img').src;
  const songName = gridItem.querySelector('img').dataset.songName;

  fullScreenOverlay.querySelector('.image-name').textContent = imgTitle;
  fullScreenOverlay.querySelector('.song-name').innerHTML = songName;
  fullScreenImage.src = imgSrc;
}
